module.exports = __webpack_public_path__ + "img/info-clover-1.7b0d8d8c.svg";